import React from "react";
import { Grid } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { RELATIONSHIP_TYPES } from "app/common/LocalConst";
import { pagingPatient } from "app/services/PatientService";
import { hideMiddleDigits } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import * as Yup from "yup";

const PopupRelatedPerson = observer(({ open, handleClose, handleAdd }) => {
    const { values: mainValues } = useFormikContext();

    return (
        <PopupForm
            open={open}
            handleClose={handleClose}
            size="sm"
            title={"Thêm mối quan hệ"}
            formik={{
                initialValues: {
                    patient: {
                        id: mainValues?.id,
                        displayName: mainValues?.displayName,
                        code: mainValues?.code
                    },
                    relatedPatient: null,
                    relationship: null,
                },
                validationSchema: Yup.object({
                    relatedPatient: Yup.object().nullable().required("Vui lòng chọn người đi cùng"),
                    relationship: Yup.string().nullable().required("Vui lòng chọn mối quan hệ"),
                }),
                onSubmit: async (values, { setSubmitting }) => {
                    handleAdd({
                        patient: values.patient,
                        relatedPatient: values.relatedPatient,
                        relationship: values.relationship,
                    });
                    setSubmitting(false);
                },
            }}
            action={({ isSubmitting }) => (
                <div className="flex-center gap-1">
                    <CommonButton type="submit"><Save className="mr-2 " /> Lưu</CommonButton>
                    <CommonButton className="btn-gray" onClick={handleClose}><Block className="mr-2" /> Đóng</CommonButton>
                </div>
            )}
        >
            {() => (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <GlobitsSelectInput label="Mối quan hệ" name="relationship" options={RELATIONSHIP_TYPES} required />
                    </Grid>
                    <Grid item xs={12}>
                        <GlobitsPagingAutocomplete
                            label="Người đi cùng (mối quan hệ)"
                            name="relatedPatient"
                            api={pagingPatient}
                            getOptionLabel={(option) => {
                                let render = option?.displayName || "";
                                if (option?.phoneNumber) render += ` - ${hideMiddleDigits(option?.phoneNumber)}`;
                                return render;
                            }}
                            required
                        />
                    </Grid>
                </Grid>
            )}
        </PopupForm>
    );
});

export default PopupRelatedPerson;
